module.exports = __webpack_public_path__ + "e0fde3245105c655eab11a3141ca02b1.svg";